import { motion } from 'framer-motion';
import PolygonBackground from '../../../components/feature/PolygonBackground';

export default function AboutSection() {
  return (
    <section id="about" className="relative py-24 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      {/* Animated Polygonal Background */}
      <PolygonBackground 
        className="opacity-50" 
        dotColor="100, 116, 139"
        lineColor="100, 116, 139"
      />

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <motion.h2 
            className="text-5xl font-light text-gray-900 mb-6 tracking-tight"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            About Us
          </motion.h2>
          <motion.div 
            className="w-24 h-1 bg-gray-900 mx-auto"
            initial={{ width: 0 }}
            whileInView={{ width: 96 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <motion.div
            className="w-full h-full"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="w-full aspect-square">
              <img 
                src="https://static.readdy.ai/image/04bffda83af79335128d062f8508dd8e/bd73b9631888c121b4aba79934a57784.jpeg"
                alt="INOCAP Strategic Investment Meeting"
                className="w-full h-full object-cover rounded-lg shadow-xl"
              />
            </div>
          </motion.div>

          {/* Right Column - Text */}
          <motion.div
            className="space-y-6"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <p className="text-xl leading-relaxed text-gray-700 text-justify">
              <strong className="text-blue-900 font-semibold">INOCAP</strong> is a private holding & advisory firm with holdings across multiple technology-driven sectors.
            </p>
            
            <p className="text-xl leading-relaxed text-gray-700 text-justify">
              We partner with <strong className="text-blue-900 font-semibold">innovative companies</strong> shaping the future of tech & energy infrastructure and provide <strong className="text-blue-900 font-semibold">operational expertise</strong> needed for sustained growth.
            </p>
            
            <p className="text-xl leading-relaxed text-gray-700 text-justify">
              In addition to managing our portfolio, INOCAP plays an active role in supporting significant acquisitions, enabling our partners to scale their capabilities, enter new markets, and unlock transformative value.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
